/* =========================================================
   RLC UNIVERSAL PRODUCT PAGE
   FAQ ACCORDION + BEFORE / AFTER SLIDER
========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* =========================================================
     FAQ ACCORDION
  ========================================================== */

  const faqItems = document.querySelectorAll(
    '.rlc-product-page .rlc-faq__item'
  );

  if (faqItems.length) {

    faqItems.forEach(function (item) {

      const summary = item.querySelector('summary');
      const answer = item.querySelector('.rlc-faq__answer');

      if (!summary || !answer) return;


      /* Initial authored-open state */
      if (item.open) {
        answer.style.height = 'auto';
      }


      summary.addEventListener('click', function (event) {

        event.preventDefault();

        if (item.open) {
          closeFaq(item, answer);
        } else {
          openFaq(item, answer);
        }

      });

    });

  }


  function openFaq(item, answer) {

    item.open = true;

    answer.style.height = '0px';

    /* Force layout */
    answer.offsetHeight;

    answer.style.height = answer.scrollHeight + 'px';


    answer.addEventListener(
      'transitionend',
      function handleOpen(event) {

        if (event.propertyName !== 'height') return;

        if (item.open) {
          answer.style.height = 'auto';
        }

        answer.removeEventListener(
          'transitionend',
          handleOpen
        );

      }
    );

  }


  function closeFaq(item, answer) {

    answer.style.height = answer.scrollHeight + 'px';

    /* Force layout */
    answer.offsetHeight;

    answer.style.height = '0px';


    answer.addEventListener(
      'transitionend',
      function handleClose(event) {

        if (event.propertyName !== 'height') return;

        item.open = false;

        answer.removeEventListener(
          'transitionend',
          handleClose
        );

      }
    );

  }


  /* =========================================================
     BEFORE / AFTER SLIDER
  ========================================================== */

  const beforeAfterSliders = document.querySelectorAll(
    '.rlc-product-page [data-rlc-before-after]'
  );

  if (beforeAfterSliders.length) {

    beforeAfterSliders.forEach(function (slider) {

      const range = slider.querySelector(
        '.rlc-before-after__range'
      );

      if (!range) return;


      function updateBeforeAfter() {
        slider.style.setProperty(
          '--rlc-before-after-position',
          range.value + '%'
        );
      }


      range.addEventListener('input', updateBeforeAfter);

      updateBeforeAfter();

    });

  }


  /* =========================================================
     PRODUCT PURCHASE CTA — UNIVERSAL SHOPIFY
     Venture / Dawn / Custom Themes
  ========================================================== */

  document.querySelectorAll(
    '.rlc-product-page .rlc-product-buy-link'
  ).forEach(function (link) {

    link.addEventListener('click', function (event) {

      event.preventDefault();

      // Find Shopify's existing product purchase form.
      const productForm = document.querySelector(
        'main form[action*="/cart/add"], ' +
        '#MainContent form[action*="/cart/add"], ' +
        '.product-single form[action*="/cart/add"], ' +
        'form[action*="/cart/add"]'
      );

      if (!productForm) {
        console.warn('RLC: Product purchase form not found.');
        return;
      }

      // Scroll to the purchase area, including size options.
      const purchaseArea = productForm.closest(
        '.product-single__meta, ' +
        '.product__info-container, ' +
        '.product__info-wrapper, ' +
        '.product-form'
      ) || productForm;

      // Account for fixed or sticky headers.
      const header = document.querySelector(
        '.shopify-section-header-sticky, ' +
        '.site-header, ' +
        '.header-wrapper'
      );

      let headerOffset = 360;

      if (header) {
        const headerStyle = window.getComputedStyle(header);

        if (
          headerStyle.position === 'fixed' ||
          headerStyle.position === 'sticky'
        ) {
          headerOffset += header.getBoundingClientRect().height;
        }
      }

      const targetY =
        purchaseArea.getBoundingClientRect().top +
        window.pageYOffset -
        headerOffset;

      window.scrollTo({
        top: Math.max(0, targetY),
        behavior: 'smooth'
      });

    });

  });


});